// @flow

export default (state: Object): string => state.mapModule.mapUrl
